// extracted by mini-css-extract-plugin
module.exports = {"Logo":"FlohmarktLogo_Logo__16smg","LogoBaseline":"FlohmarktLogo_LogoBaseline__IiXye","LogoSize":"FlohmarktLogo_LogoSize__1drCt"};